<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2 class="font-weight-bolder">{{ $t('memberDataSection.processingBatchBulkImport.title') }}</h2>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined class="mr-2" @click="goBack">
          {{ $t('back') }}
        </v-btn>
      </div>

      <v-card elevation="0" class="px-5">
        <v-card elevation="0" class="pb-bulk-tabs-card">
          <v-tabs
            v-model="tab"
            class="pb-bulk-tabs"
            background-color="transparent"
            :grow="false"
          >
            <v-tab class="text-capitalize">{{ $t('oma.import') }}</v-tab>
            <v-tab class="text-capitalize">{{ $t('oma.history') }}</v-tab>
          </v-tabs>
        </v-card>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <ProcessingBatchBulkImportTab
              @cancelImport="goBack"
              @importSuccess="onImportSuccess"
            />
          </v-tab-item>
          <v-tab-item>
            <ProcessingBatchBulkImportHistory
              v-if="tab === 1"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import ProcessingBatchBulkImportTab from "./ProcessingBatchBulkImportTab.vue";
import ProcessingBatchBulkImportHistory from "./ProcessingBatchBulkImportHistory.vue";

export default {
  name: "ProcessingBatchBulkImport",
  components: { ProcessingBatchBulkImportTab, ProcessingBatchBulkImportHistory },
  data() {
    return {
      tab: 0,
      breadcrumbs: [
        { text: this.$t("dashboard"), disabled: false, to: { name: "AdminDashboard" }, exact: true },
        { text: this.$t("memberDataSection.buyingStation"), disabled: false, to: { name: "CoffeeBuyingStationList" }, exact: true },
        { text: this.$t("memberDataSection.processingBatchBulkImport.title"), disabled: true, href: "#" },
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: "CoffeeBuyingStationList" });
    },
    onImportSuccess(detail) {
      if (detail && detail.bulkImportId != null) {
        this.$router.push({
          name: "ProcessingBatchBulkImportResult",
          params: { id: String(detail.bulkImportId) },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pb-bulk-tabs-card {
  border-bottom: 1px solid #e0e0e0;
}

.pb-bulk-tabs {
  ::v-deep .v-tabs-bar {
    background-color: #fff !important;
  }

  ::v-deep .v-slide-group__content {
    justify-content: flex-start;
  }

  ::v-deep .v-tab {
    text-transform: none;
    letter-spacing: 0;
    min-width: 100px;
    max-width: none;
    color: #787878;
    background-color: transparent;
    font-weight: 400;
  }

  ::v-deep .v-tab--active {
    color: var(--primary-color, #944a00) !important;
    background-color: #eeeeee !important;
    font-weight: 600;
  }

  ::v-deep .v-tabs-slider {
    background-color: var(--primary-color, #944a00) !important;
    height: 2px;
  }
}
</style>
